import cn from 'classnames';
import { IAskAiChatMessage, TurnStatus } from '@/creditflowresearch/domain/vo/AskAiChat';
import MessageError from './MessageError';
import StoppedNote from './StoppedNote';
import styles from '../askAiChat.module.scss';

interface IUserMessageProps {
  message: IAskAiChatMessage,
  turnStatus?: TurnStatus,
  onRetry: (messageId: string) => void,
}

const UserMessage = ({ message, turnStatus, onRetry }: IUserMessageProps) => {
  const isFailed = turnStatus === TurnStatus.Failed;

  return (
    <>
      <div className={ styles.userMessage } data-test="askAiChatUserMessage">
        { message.content }
      </div>
      { turnStatus && (
        <div
          className={ cn(styles.assistantMessage, { [styles.assistantMessageFailed]: isFailed }) }
          data-test="askAiChatTurnStatus"
        >
          { isFailed ? <MessageError onRetry={ () => onRetry(message.id) } /> : <StoppedNote /> }
        </div>
      ) }
    </>
  );
};

export default UserMessage;
